/**
 * Call Data Collection Constants
 * ENUMs pour les schémas de collecte de données d'appels
 */

// ============================================================================
// CALL PARTICIPANTS
// ============================================================================

export const PARTICIPANT_TYPES = ["target_patient", "intermediary", "wrong_person", "voicemail"] as const;
export type ParticipantType = (typeof PARTICIPANT_TYPES)[number];

// ============================================================================
// TRANSCRIPT SEGMENTS
// ============================================================================

export const SPEAKER_TYPES = ["agent", "user"] as const;
export type SpeakerType = (typeof SPEAKER_TYPES)[number];

export const SEGMENT_TYPES = ["greeting", "question", "answer", "clarification", "closing", "other"] as const;
export type SegmentType = (typeof SEGMENT_TYPES)[number];

// ============================================================================
// COLLECTED ANSWERS
// ============================================================================

/**
 * Question Types - Type sémantique de la question posée
 * Décrit CE QU'ON DEMANDE au patient
 */
export const QUESTION_TYPES = [
  "pain_level",
  "mobility",
  "medication",
  "side_effects",
  "satisfaction",
  "yes_no",
  "open_ended",
  "multiple_choice",
  "numeric",
  "date",
  "spontaneous_info",
] as const;
export type QuestionType = (typeof QUESTION_TYPES)[number];

/**
 * Value Types - Format technique de la donnée
 * Décrit COMMENT LA DONNÉE EST STOCKÉE
 *
 * Note: Utilise DATA_FORMAT_TYPES de workflow-phase-consts.ts
 * pour la cohérence avec la configuration des phases
 */
export { DATA_FORMAT_TYPES as VALUE_TYPES, type DataFormatType as ValueType } from "./workflow-phase-consts";
